import "../forecast/forecast.css"
import {Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel} from "react-accessible-accordion";

const WEEK_DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

const Forecast = ({data}) => {

    const dayInAWeek = new Date().getDay();
    const forecastDays = WEEK_DAYS.slice(dayInAWeek, WEEK_DAYS.length).concat(WEEK_DAYS.slice(0, dayInAWeek));

    var properForecast = [];

    for (var i = 8; i < data.list.length; i = i + 8) {
        properForecast.push(data.list[i]);
        console.log(data.list[i]);
    }

    console.log(data.list);

    return(
        <>
            <label className="title">Daily</label>
            <Accordion allowZeroExpanded>
                {properForecast.map((item,idx) => (
                    <AccordionItem key={idx}>
                        <AccordionItemHeading>
                            <AccordionItemButton>
                                <div className="daily-item">
                                    <img alt="weather" className="icon-small" src={`https://openweathermap.org/img/wn/${item.weather[0].icon}.png`}/>
                                    <label className="day">{forecastDays[idx]}</label>
                                    <label className="description">{item.weather[0].description}</label>
                                    <label className="min-max">{Math.round(item.main.temp_min)}°C / {Math.round(item.main.temp_max)}°C</label>
                                </div>
                            </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                            <div className="daily-details-grid">
                                <div className="daily-details-grid-item">
                                    <label className="parameter-label-forecast">Feels like</label>
                                    <label className="parameter-value-forecast">{Math.round(item.main.feels_like)}°C</label>
                                </div>
                                <div className="daily-details-grid-item">
                                    <label className="parameter-label-forecast">Wind</label>
                                    <label className="parameter-value-forecast">{item.wind.speed} m/s</label>
                                </div>
                                <div className="daily-details-grid-item">
                                    <label className="parameter-label-forecast">Humidity</label>
                                    <label className="parameter-value-forecast">{item.main.humidity}%</label>
                                </div>
                                <div className="daily-details-grid-item">
                                    <label className="parameter-label-forecast">Pressure</label>
                                    <label className="parameter-value-forecast">{item.main.pressure} hPa</label>
                                </div>
                                <div className="daily-details-grid-item">
                                    <label className="parameter-label-forecast">Clouds</label>
                                    <label className="parameter-value-forecast">{item.clouds.all}%</label>
                                </div>
                                <div className="daily-details-grid-item">
                                    <label className="parameter-label-forecast">Sea Level</label>
                                    <label className="parameter-value-forecast">{item.main.sea_level}m</label>
                                </div>
                            </div>
                        </AccordionItemPanel>
                    </AccordionItem>
                ))}
                
            </Accordion>
        </>
    )
}

export default Forecast;